import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PlayerBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/WatchControls.tsx");
